import React, { Fragment } from "react";
import { connect } from "react-redux";

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  Tooltip,
} from "recharts";

import Loader from "./../Loader/Loader.js";
import {
  Metric,
  MiniMetric,
  ComponentWithUrl,
  selectFormat,
  getCountryFlag,
  StandardTooltip,
} from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

const COLORS = ["#F9D766", "#FA6F57"];

class SummaryPaidSubs extends ComponentWithUrl {
  render() {
    const { loading, data } = this.props;

    if (loading) {
      return <Loader minHeight={400} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="mt-2 row">
        <div className="col">
          <div className="row">
            <div className="col-12">
              <Heading size={6} className={"mb-1"}>
                New Paid Subs Yesterday
              </Heading>
              <div className="d-flex">
                <Metric
                  {...data.starts.total}
                  graph={data.starts.total.chart}
                  size={"lg"}
                />
                {data.starts.us.value !== null &&
                  data.starts.ca.value !== null && (
                    <div className="ml-4 d-flex flex-column align-self-center">
                      <MiniMetric {...data.starts.us} icon={"us"} />
                      <MiniMetric {...data.starts.ca} icon={"ca"} />
                    </div>
                  )}
              </div>
            </div>

            <div className="mt-3 mb-3 col-12">
              <Heading size={6} className={"mb-1"}>
                Total Paying Subs All Platforms (As of Yesterday)
              </Heading>
              <div className="d-flex">
                <Metric {...data.totals.total} size={"lg"} />
                {data.starts.us.value !== null &&
                  data.starts.ca.value !== null && (
                    <div className="ml-4 d-flex flex-column align-self-center">
                      <MiniMetric {...data.totals.us} icon={"us"} />
                      <MiniMetric {...data.totals.ca} icon={"ca"} />
                    </div>
                  )}
              </div>
            </div>
          </div>

          <div className="mt-4 col-12">
            <h6>Monthly Growth</h6>
            <ResponsiveContainer height={100} width="100%">
              <BarChart
                width={150}
                height={100}
                data={data.growth_by_month}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 0,
                }}
              >
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Month
                                    </span>
                                    <span className="standard-tooltip__value-header">
                                      {payload.name}
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div
                                      className="standard-tooltip__item"
                                      key={key}
                                    >
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: "#FA6E57" }}
                                        ></span>
                                        {payload[key].payload.label}
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
                <defs>
                  <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                    <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                  </linearGradient>
                </defs>
                <Bar dataKey="value" fillOpacity={1} fill="url(#colorUv)" />
                <XAxis
                  dataKey="label"
                  axisLine={false}
                  tickLine={false}
                  tick={{
                    strokeWidth: 0,
                    fill: "#25263F",
                  }}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {data.today_totals.chart[0].value !== null &&
            data.today_totals.chart[1].value !== null && (
              <div className="mt-3 d-flex align-items-center">
                <PieChart height={70} width={70}>
                  <Pie
                    dataKey="value"
                    data={data.today_totals.chart}
                    outerRadius="100%"
                    innerRadius="65%"
                  >
                    {data.today_totals.chart.map((entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                    ))}
                  </Pie>
                  <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    className="piechart-metric__small"
                  >
                    {selectFormat(
                      "percentage",
                      data.today_totals.chart[1].value
                    )}
                  </text>
                </PieChart>
                <div className="ml-4">
                  <span className="mt-2 legend mt-md-0">
                    <span
                      className="legend__icon"
                      style={{ background: "#FA6F57" }}
                    ></span>
                    <span className="legend__text">{getCountryFlag("us")}</span>
                  </span>
                  <span className="mt-2 legend mt-md-0">
                    <span
                      className="legend__icon"
                      style={{ background: "#F9D766" }}
                    ></span>
                    <span className="legend__text">
                      {getCountryFlag("canada")}
                    </span>
                  </span>
                  <Heading size={6} className={"mb-0"}>
                    Total Current Subscribers
                  </Heading>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(SummaryPaidSubs);
